import { FC } from 'react';
import styles from './style.module.css';
export type MessageFromUbieAimonStyle = 'no-margin-left' | 'has-margin-left' | 'alert-top';

interface Props {
  label: string;
  style: MessageFromUbieAimonStyle;
}

export const MedicalInstitutionDataFieldSpecialHolidays: FC<Props> = ({ label, style }) => {
  return (
    <div
      className={
        style === 'has-margin-left'
          ? styles.MedicalInstitutionDataFieldSpecialHolidays
          : style === 'no-margin-left'
          ? styles.MedicalInstitutionDataFieldSpecialHolidaysNoMargin
          : styles.MedicalInstitutionDataFieldSpecialHolidaysAlertTop
      }
    >
      <p>{label}</p>
    </div>
  );
};
